import { Filter } from "@/models/Pageable"

export type FullTextSearchByFieldName = "firstName" | "lastName" | "email"

export class FilterUser extends Filter {
  text = ""
  projectId = ""
  teamId = ""
  accountId = ""
  isSuperadmin = false
  forSearch = false
  extended = false
  includeDemo = false
  includeEnabledOnly = false
  previousTaskOwnersByItemId = ""
  currentTaskOwnersByItemId = ""
  excludeTeamIds: string[] = []
  excludeEmails: string[] = []
  fullTextSearchByFieldNames: FullTextSearchByFieldName[] = ["firstName", "lastName"]
  emailVerified?: boolean
  enabled?: boolean
  emailUnreachable?: boolean
  constructor(props?: Partial<FilterUser>) {
    super(props as Filter)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    const data = {
      text: this.text,
      projectId: this.projectId,
      accountId: this.accountId,
      fullTextSearchByFieldNames: this.fullTextSearchByFieldNames,
      teamId: this.teamId,
      includeDemo: this.includeDemo,
      includeEnabledOnly: this.includeEnabledOnly,
      previousTaskOwnersByItemId: this.previousTaskOwnersByItemId,
      currentTaskOwnersByItemId: this.currentTaskOwnersByItemId,
      excludeTeamIds: this.excludeTeamIds,
      excludeEmails: this.excludeEmails,
      emailVerified: this.emailVerified,
      enabled: this.enabled,
      emailUnreachable: this.emailUnreachable
    }

    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterUser(props)
  }

  static createDefault() {
    return new FilterUser()
  }
}
